import React from "react";

import { PreviewLayout } from "./";
import { Typography } from "@/components/Typography";
import { Carousel } from "@/components/Carousel";
import { Link } from "../Link";

import { checkValidURL } from "@/utils/formHelper";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";

export default function PreviewImages(props: QRProps<"image">) {
  const qrEditorContextData = React.useContext<QREditorContextProps<"image">>(QREditorContext);
  const data = props?.data || qrEditorContextData?.qrData.data;
  const isInitPreview = props?.initPreview;
  const isPreview = props?.preview;

  const {
    albumDescription,
    albumTitle,
    albumWebsite,
    buttonText,
    buttonUrl,
    imageUrls,
    themeColor,
  } = data;

  React.useEffect(() => {
    // avoid go to next step if image URLS haven't been given
    if (!isInitPreview) {
      const imageExist = imageUrls && imageUrls.length > 0;
      !imageExist
        ? qrEditorContextData.setValidationError(true)
        : qrEditorContextData.setValidationError(false);
    }
  }, [data]);

  return (
    <PreviewLayout
      page="image"
      dataQA="preview-image-container"
      backgroundColor={themeColor?.backgroundColor}
      includeBrowser
      isInitPreview={isInitPreview}>
      {albumTitle && (
        <div className="image__album-name">
          <Typography
            Tag="p"
            size="l"
            classname="u-bold u-spacing-4">
            {albumTitle}
          </Typography>
        </div>
      )}

      {albumDescription && (
        <div className="image__album-description">
          <Typography
            Tag="p"
            size="s">
            {albumDescription}
          </Typography>
        </div>
      )}

      {imageUrls?.length > 0 && (
        <div style={{ position: "relative" }}>
          <div
            className="image-background-divider-top"
            style={{ backgroundColor: themeColor?.buttonColor }}
          />
          <div className="image-background-divider-bottom" />
          <div className={`image-carousel-background ${isInitPreview ? "initPreview" : ""}`}>
            {imageUrls && (
              <Carousel
                images={imageUrls}
                expandable={!isPreview}
              />
            )}
            {buttonText && imageUrls.length > 0 && (
              <Link
                externalLink
                className="button u-spacing-5 image-button"
                href={checkValidURL(buttonUrl) || ""}
                style={{ backgroundColor: themeColor?.buttonColor }}
                prefetch={false}>
                <span
                  data-testid="button-label"
                  className="button__text">
                  {buttonText}
                </span>
              </Link>
            )}
          </div>
        </div>
      )}

      <div className="qr-content ">
        {albumWebsite && (
          <div className="image__album-website">
            <Link
              externalLink
              className="Preview-layout__link"
              href={checkValidURL(albumWebsite) || ""}
              prefetch={false}>
              {albumWebsite}
            </Link>
          </div>
        )}
      </div>
    </PreviewLayout>
  );
}
